import { Stack } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useAtomValue } from "jotai";
import { memo } from "react";
import { APP_ELEMENT_DIMENSIONS } from "../../constants";
import { baseAtom } from "../../stores/jotai/base";
import { cohortPeriodsAtom } from "../../stores/jotai/cohortPeriods";
import { teamsAtom } from "../../stores/jotai/teams/teams";
import { buildPresentationScoreChart } from "../../util/scoringUtils";

const ScoringChart = ({comments}: {comments: any[]}) => {
    const base = useAtomValue(baseAtom);
    const periods = useAtomValue(cohortPeriodsAtom);
    const teams=useAtomValue(teamsAtom);

    return (
        <Stack
            sx={{
                width: `calc(100% - ${APP_ELEMENT_DIMENSIONS.SCORING.OVERVIEW_STAT.WIDTH})`,
                minWidth: "300px",
                flexGrow: 1,
                maxWidth: "100%",
            }}
        >
            <HighchartsReact
                highcharts={Highcharts}
                options={buildPresentationScoreChart(
                    base?.cohort,
                    base?.team?.groupID,
                    comments,
                    teams,
                    periods
                )}
            />
        </Stack>
    );
};

export default memo(ScoringChart);
